/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Facts_GdprInputs */

const en_about_facts_gdpr = /** @type {(inputs: About_Facts_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU Data Processing`)
};

const de_about_facts_gdpr = /** @type {(inputs: About_Facts_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-Datenverarbeitung`)
};

const fr_about_facts_gdpr = /** @type {(inputs: About_Facts_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement des donnees UE`)
};

const es_about_facts_gdpr = /** @type {(inputs: About_Facts_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesamiento de datos UE`)
};

const it_about_facts_gdpr = /** @type {(inputs: About_Facts_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione dati UE`)
};

const nl_about_facts_gdpr = /** @type {(inputs: About_Facts_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-gegevensverwerking`)
};

const pl_about_facts_gdpr = /** @type {(inputs: About_Facts_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przetwarzanie danych w UE`)
};

const fi_about_facts_gdpr = /** @type {(inputs: About_Facts_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-tietojenkasittely`)
};

const da_about_facts_gdpr = /** @type {(inputs: About_Facts_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-databehandling`)
};

const sv_about_facts_gdpr = /** @type {(inputs: About_Facts_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-databehandling`)
};

/**
* | output |
* | --- |
* | "EU Data Processing" |
*
* @param {About_Facts_GdprInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_facts_gdpr = /** @type {((inputs?: About_Facts_GdprInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Facts_GdprInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_facts_gdpr(inputs)
	if (locale === "fr") return fr_about_facts_gdpr(inputs)
	if (locale === "es") return es_about_facts_gdpr(inputs)
	if (locale === "it") return it_about_facts_gdpr(inputs)
	if (locale === "nl") return nl_about_facts_gdpr(inputs)
	if (locale === "pl") return pl_about_facts_gdpr(inputs)
	if (locale === "fi") return fi_about_facts_gdpr(inputs)
	if (locale === "da") return da_about_facts_gdpr(inputs)
	if (locale === "sv") return sv_about_facts_gdpr(inputs)
	return en_about_facts_gdpr(inputs)
});